import { Switch } from 'antd'
import { useState } from 'react'

export const SwitchControl = ({ value, onChange, disabled = false }) => {
  const [checked, setChecked] = useState(value)

  return (
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={(val) => {
        onChange(val)
        setChecked(val)
      }}
    />
  )
}
